import { LayoutList, ListChecks } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminSkillGridsRoutes } from './routes';
import { CHECKBOX_LINK_TAB } from './skillGridPanels';

export const adminSkillGridsManifest: FeatureManifest = {
  id: 'admin-skill-grids',
  contexts: [CONTEXTS.ADMIN_SKILL_GRIDS, CONTEXTS.ADMIN_SKILL_GRID_FORM],

  routes: [
    {
      routes: adminSkillGridsRoutes,
      errorFallbackLabel: 'Grilles d’évaluation',
      guard: ADMIN_GUARD,
    },
  ],

  centerView: {
    [CONTEXTS.ADMIN_SKILL_GRIDS]: lazyView(
      () => import('../views/AdminSkillGridsListView'),
      'AdminSkillGridsListView',
    ),
    [CONTEXTS.ADMIN_SKILL_GRID_FORM]: lazyView(
      () => import('../views/AdminSkillGridFormView'),
      'AdminSkillGridFormView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_SKILL_GRIDS]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
        [CONTEXTS.ADMIN_SKILL_GRID_FORM]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
    // Right panel: on-demand "add a checkbox" form (checkbox + weight), opened
    // from the checkboxes editor. Same for create and edit.
    right: {
      tabs: {
        [CONTEXTS.ADMIN_SKILL_GRID_FORM]: [
          {
            id: CHECKBOX_LINK_TAB,
            label: 'Ajouter une checkbox',
            icon: ListChecks,
            view: lazyView(() => import('../views/AdminCheckboxLinkView'), 'AdminCheckboxLinkView'),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_SKILL_GRIDS]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_SKILL_GRID_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
  },
};
